import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectMixedContentFilterClauses } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';
import { updateTotalUserCountForServerUserSpace } from '~src/userManagement/sagas/ServerUserSpaceSagas';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllServerUsersSpace, AllServerUsersSpaceDispatchProps, AllServerUsersSpaceOwnProps, AllServerUsersSpaceStateProps } from './AllServerUsersSpace';

const mapStateToProps: MapStateToProps<AllServerUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  mixedContentFilterMap: selectMixedContentFilterClauses(state)
});

const mapDispatchToProps: MapDispatchToProps<AllServerUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
  updateTotalUserCountForServerUserSpace
}, dispatch);

export const ConnectedAllServerUsersSpace: React.ComponentClass<AllServerUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllServerUsersSpace);
